import type { VariantConfig } from "./types";

export function getAllocation<T extends readonly string[]>(
  names: T,
  index: number,
) {
  if (names.length < 2) {
    throw new Error(`Could not get allocation for ${names}`);
  }

  const lowerBound = (1 / names.length) * index * 100;
  const upperBound = (1 / names.length) * (index + 1) * 100;

  return [lowerBound, upperBound] as const;
}

export function getVariants<T extends readonly string[]>(
  names: T,
): Record<(typeof names)[number], VariantConfig> {
  const variants: Record<string, VariantConfig> = {};

  // Ensure contains "A-control" control group
  if (!names.includes("A-control")) {
    throw Error("No control group found with name 'A-control'");
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const [idx, name] of names.entries()) {
    variants[name] = {
      allocation: getAllocation(names, idx),
    };
  }

  return variants;
}
